import { render, staticRenderFns } from "./AlignIcon.vue?vue&type=template&id=5c2ed9f3"
import script from "./AlignIcon.vue?vue&type=script&lang=js"
export * from "./AlignIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports